import React from 'react';
import Badge from 'housecall-ui/dist/DesignSystem/DataDisplay/Badges/Badge';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Tab from 'housecall-ui/dist/DesignSystem/Navigation/Tabs/Tab';
import Tabs from 'housecall-ui/dist/DesignSystem/Navigation/Tabs/Tabs';
import makeStyles from 'housecall-ui/dist/DesignSystem/Styles/makeStyles';
import PropTypes from 'prop-types';

import MoreDropdownTab from './MoreDropdownTab';

const useStyles = makeStyles(() => ({
  firstTabEdge: {
    '& [role=tab]:first-child': {
      paddingLeft: 0,
    },
  },
}));

function NavigationTabs({ activeTab, toolbarTabs, dropdownList }) {
  const { firstTabEdge } = useStyles();
  const getLabel = (text, badgeCount) => (
    <Badge color="info" badgeContent={badgeCount} version="v2">
      <Typography variant="subtitle2" color="textPrimary">
        {text}
      </Typography>
    </Badge>
  );
  const value = toolbarTabs.some((tab) => tab.value === activeTab) ? activeTab : false;

  return (
    <Tabs value={value} classes={{ root: firstTabEdge }} version="v2">
      {toolbarTabs.map((item, index) => (
        <Tab
          key={index}
          version="v2"
          label={getLabel(item.label, item.badgeCount)}
          value={item.value}
          href={item.href}
          onClick={item.onClick}
        />
      ))}
      {dropdownList.length && <MoreDropdownTab dropdownList={dropdownList} activeTab={activeTab} />}
    </Tabs>
  );
}

NavigationTabs.propTypes = {
  activeTab: PropTypes.string.isRequired,
  toolbarTabs: PropTypes.arrayOf(PropTypes.object).isRequired,
  dropdownList: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default NavigationTabs;
